import PropTypes from 'prop-types';
import React from 'react';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';

import OnOffSwitch from './on_off_switch.jsx';
import { swEnabled } from '../engage_cache.js';

// OnOffSwitch requires an onChange
const NOOP = () => null;

export default function ContentMenu(props) {
    const {
        content,
        isInstructor,
        offlineStatus,
        isConnected,
        isBlocked,
        hideSharingQA,
        onNavToAllNotes,
        push,
    } = props;
    const onSelection = value => {
        switch (value) {
            case 'delete':
                props.onDelete();
                break;
            case 'offline':
                props.toggleOffline(content);
                break;
            case 'sharing':
                push(`content-${content.id}/address/${0}/sharing`);
                break;
            case 'print':
                push(`content-${content.id}/address/${0}/print`);
                break;
            case 'all-notes':
                push(`notes/content-${content.id}`);
                onNavToAllNotes();
                break;
        }
    };

    const isTextContent = content.is_finalized && content.media_type === 'text';

    const isDownloaded = offlineStatus != null && offlineStatus.localPages > 0;

    const items = [];

    if (
        swEnabled &&
        isTextContent &&
        (isConnected || isDownloaded) &&
        !isBlocked
    ) {
        items.push(
            <MenuItem
                aria-label="Keep on device"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="offline"
                tag="li"
                value="offline"
            >
                <OnOffSwitch
                    checked={isDownloaded}
                    onChange={NOOP}
                    position="left"
                >
                    Keep on device
                </OnOffSwitch>
            </MenuItem>
        );
    }

    if (isTextContent && !isInstructor && !isBlocked && !hideSharingQA) {
        items.push(
            <MenuItem
                aria-label="Sharing"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="sharing"
                tag="li"
                value="sharing"
            >
                <i className="cl-icon cl-icon-share" />
                Sharing
            </MenuItem>
        );
    }
    if (isTextContent && isConnected && !isBlocked) {
        items.push(
            <MenuItem
                aria-label="Print"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="print"
                tag="li"
                value="print"
            >
                <i className="cl-icon cl-icon-print" />
                Print
            </MenuItem>
        );
    }

    if (isTextContent && !isBlocked) {
        items.push(
            <MenuItem
                aria-label="All notes"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="all-notes"
                tag="li"
                value="all-notes"
            >
                <i className="cl-icon cl-icon-notes" />
                View all notes
            </MenuItem>
        );
    }

    if (isInstructor && !content.is_courseload_administered && isConnected) {
        items.push(
            <MenuItem
                aria-label="Delete"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="delete"
                tag="li"
                value="delete"
            >
                <i className="cl-icon cl-icon-trash-o" />
                Delete
            </MenuItem>
        );
    }

    return items.length ? (
        <div className="react-dropdown-wrapper">
            <Wrapper className="react-dropdown" onSelection={onSelection}>
                <Button className="react-dropdown-button">
                    <span aria-hidden>...</span>
                    <span className="aural">Options for {content.title}</span>
                </Button>
                <Menu className="react-dropdown-menu">
                    <ul>{items}</ul>
                </Menu>
            </Wrapper>
        </div>
    ) : null;
}
ContentMenu.propTypes = {
    isInstructor: PropTypes.bool.isRequired,
    offlineStatus: PropTypes.shape({
        totalPages: PropTypes.number.isRequired,
        localPages: PropTypes.number.isRequired,
        error: PropTypes.string,
        deleting: PropTypes.bool,
    }),
    content: PropTypes.shape({
        id: PropTypes.number.isRequired,
        is_courseload_administered: PropTypes.bool.isRequired,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    analyticsMode: PropTypes.oneOf(['term', 'section']).isRequired,
    section: PropTypes.shape({
        id: PropTypes.number.isRequired,
        term_id: PropTypes.number.isRequired,
    }).isRequired,
    toggleOffline: PropTypes.func.isRequired,
    isConnected: PropTypes.bool.isRequired,
    isBlocked: PropTypes.bool.isRequired,
    hideSharingQA: PropTypes.bool.isRequired,
    onNavToAllNotes: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/content_menu.ui.jsx